/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'teller-online-libraries/core';
import { TellerOnlineWindowService } from "teller-online-libraries/shared";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CartApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return CartApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) CartApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        CartApiClient._baseUrl = baseUrl;
    }

    /**
     * Create a cart
     * @return OK
     */
    createCart(): Observable<CartDto> {
        let url_ = this.baseUrl + "/cart/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateCart(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateCart(<any>r));
                } catch (e) {
                    return <Observable<CartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCart(response: HttpResponseBase): Observable<CartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the cart for this user and merge with a session cart if necessary, or save session cart to this user
     * @param cartGuid (optional) Unique GUID of cart
     * @return OK
     */
    retrieveUserCart(cartGuid: string | null | undefined): Observable<CartResponseDto> {
        let url_ = this.baseUrl + "/retrieve-cart/?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid !== undefined && cartGuid !== null)
            url_ += "CartGuid=" + encodeURIComponent("" + cartGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRetrieveUserCart(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRetrieveUserCart(<any>r));
                } catch (e) {
                    return <Observable<CartResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRetrieveUserCart(response: HttpResponseBase): Observable<CartResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve information about a cart
     * @param cartGuid Unique GUID of cart
     * @param paymentMethodType Payment method type (CreditCard or ECheck)
     * @return OK
     */
    getCart(cartGuid: string, paymentMethodType: PaymentMethodTypeEnumDto): Observable<CartResponseDto> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/{PaymentMethodType}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCart(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCart(<any>r));
                } catch (e) {
                    return <Observable<CartResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCart(response: HttpResponseBase): Observable<CartResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add item to a cart
     * @param cartGuid Unique GUID of cart
     * @param checkingOut Flag indicating if this request came from the checkout page, indicating this user is currently checking out
     * @param body (optional) 
     * @return OK
     */
    addItem(cartGuid: string | null, checkingOut: boolean, body: ItemDto | undefined): Observable<AddItemResponseDto> {
        let url_ = this.baseUrl + "/cart/items?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined)
            throw new Error("The parameter 'cartGuid' must be defined.");
        else if(cartGuid !== null)
            url_ += "CartGuid=" + encodeURIComponent("" + cartGuid) + "&";
        if (checkingOut === undefined || checkingOut === null)
            throw new Error("The parameter 'checkingOut' must be defined and cannot be null.");
        else
            url_ += "CheckingOut=" + encodeURIComponent("" + checkingOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddItem(<any>r));
                } catch (e) {
                    return <Observable<AddItemResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddItemResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddItem(response: HttpResponseBase): Observable<AddItemResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddItemResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update item in cart
     * @param cartGuid Unique GUID of cart
     * @param itemGuid GUID of item in the cart
     * @param checkingOut Flag indicating if this request came from the checkout page, indicating this user is currently checking out
     * @param body (optional) 
     * @return OK
     */
    updateItem(cartGuid: string, itemGuid: string, checkingOut: boolean, body: ItemDto | undefined): Observable<CartResponseDto> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/items/{ItemGuid}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (itemGuid === undefined || itemGuid === null)
            throw new Error("The parameter 'itemGuid' must be defined.");
        url_ = url_.replace("{ItemGuid}", encodeURIComponent("" + itemGuid));
        if (checkingOut === undefined || checkingOut === null)
            throw new Error("The parameter 'checkingOut' must be defined and cannot be null.");
        else
            url_ += "CheckingOut=" + encodeURIComponent("" + checkingOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateItem(<any>r));
                } catch (e) {
                    return <Observable<CartResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateItem(response: HttpResponseBase): Observable<CartResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refresh item in cart
     * @param cartGuid Unique GUID of cart
     * @param itemGuid GUID of item in the cart
     * @return OK
     */
    refreshItem(cartGuid: string, itemGuid: string): Observable<RefreshItemResponseDto> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/items/{ItemGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (itemGuid === undefined || itemGuid === null)
            throw new Error("The parameter 'itemGuid' must be defined.");
        url_ = url_.replace("{ItemGuid}", encodeURIComponent("" + itemGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRefreshItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRefreshItem(<any>r));
                } catch (e) {
                    return <Observable<RefreshItemResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshItemResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshItem(response: HttpResponseBase): Observable<RefreshItemResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshItemResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove an item from an cart
     * @param cartGuid Unique GUID of cart
     * @param itemGuid GUID of item to remove
     * @param removeAll flag to indicate if we remove all items with this BSI key, or just this specific item
     * @param checkingOut Flag indicating if this request came from the checkout page, indicating this user is currently checking out
     * @return OK
     */
    removeItem(cartGuid: string, itemGuid: string, removeAll: boolean, checkingOut: boolean): Observable<CartResponseDto> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/items/{ItemGuid}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (itemGuid === undefined || itemGuid === null)
            throw new Error("The parameter 'itemGuid' must be defined.");
        url_ = url_.replace("{ItemGuid}", encodeURIComponent("" + itemGuid));
        if (removeAll === undefined || removeAll === null)
            throw new Error("The parameter 'removeAll' must be defined and cannot be null.");
        else
            url_ += "RemoveAll=" + encodeURIComponent("" + removeAll) + "&";
        if (checkingOut === undefined || checkingOut === null)
            throw new Error("The parameter 'checkingOut' must be defined and cannot be null.");
        else
            url_ += "CheckingOut=" + encodeURIComponent("" + checkingOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveItem(<any>r));
                } catch (e) {
                    return <Observable<CartResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveItem(response: HttpResponseBase): Observable<CartResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * populate the cart user details before payment
     * @param cartGuid Unique GUID of cart
     * @param guestEmailAddress (optional) Guest email address
     * @param rememberPaymentMethod Indicates if the credit card or echeck should be saved
     * @param paymentMethodId Payment method
     * @param paymentMethodType Payment method type (CreditCard or ECheck)
     * @param paymentProcessor (optional) What payment processor will be handling this payment (required if PaymentMethodType specified)
     * @return OK
     */
    populateCartUserDetails(cartGuid: string, guestEmailAddress: string | undefined, rememberPaymentMethod: boolean, paymentMethodId: number | null, paymentMethodType: PaymentMethodTypeEnumDto, paymentProcessor: PaymentIntegrationEnumDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/populateCartUserDetails?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (guestEmailAddress === null)
            throw new Error("The parameter 'guestEmailAddress' cannot be null.");
        else if (guestEmailAddress !== undefined)
            url_ += "GuestEmailAddress=" + encodeURIComponent("" + guestEmailAddress) + "&";
        if (rememberPaymentMethod === undefined || rememberPaymentMethod === null)
            throw new Error("The parameter 'rememberPaymentMethod' must be defined and cannot be null.");
        else
            url_ += "RememberPaymentMethod=" + encodeURIComponent("" + rememberPaymentMethod) + "&";
        if (paymentMethodId === undefined)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        else if(paymentMethodId !== null)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined and cannot be null.");
        else
            url_ += "PaymentMethodType=" + encodeURIComponent("" + paymentMethodType) + "&";
        if (paymentProcessor !== undefined && paymentProcessor !== null)
            url_ += "PaymentProcessor=" + encodeURIComponent("" + paymentProcessor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPopulateCartUserDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPopulateCartUserDetails(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPopulateCartUserDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change the cart status to Open triggered by User
     * @param cartGuid Unique GUID of cart
     * @return OK
     */
    userSetCartOpen(cartGuid: string): Observable<void> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/userSetCartOpen";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUserSetCartOpen(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUserSetCartOpen(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUserSetCartOpen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change the cart status to specified status according to internal methods.
    Only currently supported statuses are Open and CheckingOut
     * @param cartGuid Unique GUID of cart
     * @param status The new status of the cart
     * @return OK
     */
    updateCartStatus(cartGuid: string, status: string): Observable<void> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/{Status}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{Status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateCartStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateCartStatus(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCartStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add an event to the cart
     * @param cartGuid Unique GUID of cart
     * @param paymentIdentifier (optional) Unique identifier for the payment
     * @param body (optional) 
     * @return OK
     */
    addCartEvent(cartGuid: string, paymentIdentifier: string | null | undefined, body: AddCartEventRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/event?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentIdentifier !== undefined && paymentIdentifier !== null)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddCartEvent(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddCartEvent(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddCartEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve information about payment details of cart
     * @param cartGuid Unique GUID of cart
     * @return OK
     */
    getCartPaymentDetails(cartGuid: string): Observable<CartPaymentDetailsDto> {
        let url_ = this.baseUrl + "/cart/{CartGuid}/getPaymentDetails";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCartPaymentDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCartPaymentDetails(<any>r));
                } catch (e) {
                    return <Observable<CartPaymentDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CartPaymentDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCartPaymentDetails(response: HttpResponseBase): Observable<CartPaymentDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartPaymentDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentMethodsApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return PaymentMethodsApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) PaymentMethodsApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        PaymentMethodsApiClient._baseUrl = baseUrl;
    }

    /**
     * Get all the payment methods of current user to list for modification on the profile
     * @return OK
     */
    getPaymentMethods(): Observable<PaymentMethodDto[]> {
        let url_ = this.baseUrl + "/paymentmethods/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPaymentMethods(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPaymentMethods(<any>r));
                } catch (e) {
                    return <Observable<PaymentMethodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the saved payment methods for the effective user to use for checkout
     * @return OK
     */
    getSavedPaymentMethods(): Observable<SavedPaymentMethodDto[]> {
        let url_ = this.baseUrl + "/paymentmethods/saved";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSavedPaymentMethods(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSavedPaymentMethods(<any>r));
                } catch (e) {
                    return <Observable<SavedPaymentMethodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SavedPaymentMethodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSavedPaymentMethods(response: HttpResponseBase): Observable<SavedPaymentMethodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SavedPaymentMethodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a specific payment method
     * @param methodId Unique ID of payment method
     * @return OK
     */
    getPaymentMethod(methodId: number): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/paymentmethods/{MethodId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (methodId === undefined || methodId === null)
            throw new Error("The parameter 'methodId' must be defined.");
        url_ = url_.replace("{MethodId}", encodeURIComponent("" + methodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<PaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentMethod(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * set default payment method
     * @param methodId Unique ID of payment method
     * @return OK
     */
    setDefaultPaymentMethod(methodId: number): Observable<void> {
        let url_ = this.baseUrl + "/paymentmethods/{MethodId}/setdefault";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (methodId === undefined || methodId === null)
            throw new Error("The parameter 'methodId' must be defined.");
        url_ = url_.replace("{MethodId}", encodeURIComponent("" + methodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetDefaultPaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetDefaultPaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultPaymentMethod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove paymentMethod
     * @param methodId Unique ID of payment Method
     * @return OK
     */
    removePaymentMethod(methodId: number): Observable<void> {
        let url_ = this.baseUrl + "/paymentmethods/{MethodId}/remove";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (methodId === undefined || methodId === null)
            throw new Error("The parameter 'methodId' must be defined.");
        url_ = url_.replace("{MethodId}", encodeURIComponent("" + methodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemovePaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemovePaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePaymentMethod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PageApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return PageApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) PageApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        PageApiClient._baseUrl = baseUrl;
    }

    /**
     * fetches the details of the page
     * @param pageId Unique ID of page
     * @return OK
     */
    getPageDetails(pageId: number): Observable<PageDto> {
        let url_ = this.baseUrl + "/page/{PageId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{PageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPageDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPageDetails(<any>r));
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageDetails(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PageitemtypeApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return PageitemtypeApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) PageitemtypeApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        PageitemtypeApiClient._baseUrl = baseUrl;
    }

    /**
     * A full representation of a page item type.
     * @param pageId Unique ID of page
     * @param pageItemTypeId Unique ID of pageitemtype
     * @return OK
     */
    getPageItemTypeDetails(pageId: number, pageItemTypeId: number): Observable<PageItemTypeDto> {
        let url_ = this.baseUrl + "/pageitemtype/{PageId}/{PageItemTypeId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{PageId}", encodeURIComponent("" + pageId));
        if (pageItemTypeId === undefined || pageItemTypeId === null)
            throw new Error("The parameter 'pageItemTypeId' must be defined.");
        url_ = url_.replace("{PageItemTypeId}", encodeURIComponent("" + pageItemTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPageItemTypeDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPageItemTypeDetails(<any>r));
                } catch (e) {
                    return <Observable<PageItemTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageItemTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageItemTypeDetails(response: HttpResponseBase): Observable<PageItemTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageItemTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SearchApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return SearchApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) SearchApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        SearchApiClient._baseUrl = baseUrl;
    }

    /**
     * Search for items to be paid
     * @param pageId ID of Page to fetch in
     * @param cartGuid (optional) Cart GUID associated to the user
     * @param searchValues Search values
     * @return OK
     */
    searchForItems(pageId: number, cartGuid: string | undefined, searchValues: { [key: string]: string; }): Observable<ItemDto[]> {
        let url_ = this.baseUrl + "/search?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined and cannot be null.");
        else
            url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
        if (cartGuid === null)
            throw new Error("The parameter 'cartGuid' cannot be null.");
        else if (cartGuid !== undefined)
            url_ += "CartGuid=" + encodeURIComponent("" + cartGuid) + "&";
        if (searchValues === undefined || searchValues === null)
            throw new Error("The parameter 'searchValues' must be defined and cannot be null.");
        else
            for (let attr in searchValues) {
                if (searchValues.hasOwnProperty(attr)) {
                    url_ += "SearchValues[" + attr + "]=" + encodeURIComponent("" + (<any>searchValues)[attr]) + "&";
                }
            }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearchForItems(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearchForItems(<any>r));
                } catch (e) {
                    return <Observable<ItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearchForItems(response: HttpResponseBase): Observable<ItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gives template of the given search type, empty string returned if no template available
     * @param fetchTypeName Name of fetch type to use
     * @return OK
     */
    searchTypeTemplate(fetchTypeName: string): Observable<string> {
        let url_ = this.baseUrl + "/search/type-template/?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (fetchTypeName === undefined || fetchTypeName === null)
            throw new Error("The parameter 'fetchTypeName' must be defined and cannot be null.");
        else
            url_ += "FetchTypeName=" + encodeURIComponent("" + fetchTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSearchTypeTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSearchTypeTemplate(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSearchTypeTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves initial data came via extarnal request - search by data transfer
     * @param cartId (optional) ID of the cart
     * @param backUrl (optional) External back URL
     * @return OK
     */
    saveSearchExternal(cartId: number | undefined, backUrl: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/search/save/?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartId === null)
            throw new Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "CartId=" + encodeURIComponent("" + cartId) + "&";
        if (backUrl === null)
            throw new Error("The parameter 'backUrl' cannot be null.");
        else if (backUrl !== undefined)
            url_ += "backUrl=" + encodeURIComponent("" + backUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSaveSearchExternal(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSaveSearchExternal(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveSearchExternal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get lookahead search results based on user input
     * @param pageId ID of the page to perform the lookahead against.
     * @param searchType Type of the search to use for the lookahead.
     * @param partialSearch Partial search string to match results on
     * @return OK
     */
    lookaheadSearch(pageId: number, searchType: string, partialSearch: string): Observable<string[]> {
        let url_ = this.baseUrl + "/search/lookahead/{PageId}/{SearchType}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{PageId}", encodeURIComponent("" + pageId));
        if (searchType === undefined || searchType === null)
            throw new Error("The parameter 'searchType' must be defined.");
        url_ = url_.replace("{SearchType}", encodeURIComponent("" + searchType));
        if (partialSearch === undefined || partialSearch === null)
            throw new Error("The parameter 'partialSearch' must be defined and cannot be null.");
        else
            url_ += "PartialSearch=" + encodeURIComponent("" + partialSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLookaheadSearch(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLookaheadSearch(<any>r));
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processLookaheadSearch(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserPaymentsApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return UserPaymentsApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) UserPaymentsApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        UserPaymentsApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve users payments
     * @return OK
     */
    getUserPayments(): Observable<UserPaymentsDto[]> {
        let url_ = this.baseUrl + "/user-payments/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
                } catch (e) {
                    return <Observable<UserPaymentsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPaymentsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPayments(response: HttpResponseBase): Observable<UserPaymentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPaymentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReceiptDownloadApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return ReceiptDownloadApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) ReceiptDownloadApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        ReceiptDownloadApiClient._baseUrl = baseUrl;
    }

    /**
     * Download the teller receipt
     * @param paymentIdentifier Unique identifier for the payment
     * @return Receipt PDF File
     */
    downloadReceipt(paymentIdentifier: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/receipt-download/{PaymentIdentifier}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadReceipt(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadReceipt(<any>r));
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadReceipt(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download all receipts associated with a cart
     * @param cartGuid Unique identifier for the cart
     * @return Zip archive containing receipt pdf files
     */
    downloadAllReceipts(cartGuid: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/receipt-download/all/{CartGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/zip"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadAllReceipts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadAllReceipts(<any>r));
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadAllReceipts(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileDownloadApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return FileDownloadApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) FileDownloadApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        FileDownloadApiClient._baseUrl = baseUrl;
    }

    /**
     * Download the file corresponding to the DownloadIdentifier from a given business system.
     * @param businessSystemNo Number of the business system to get the file from
     * @param downloadIdentifier Identifier of the the file to download
     * @return File to be downloaded
     */
    getFileDownload(businessSystemNo: number, downloadIdentifier: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/file-download/{BusinessSystemNo}/{DownloadIdentifier}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (businessSystemNo === undefined || businessSystemNo === null)
            throw new Error("The parameter 'businessSystemNo' must be defined.");
        url_ = url_.replace("{BusinessSystemNo}", encodeURIComponent("" + businessSystemNo));
        if (downloadIdentifier === undefined || downloadIdentifier === null)
            throw new Error("The parameter 'downloadIdentifier' must be defined.");
        url_ = url_.replace("{DownloadIdentifier}", encodeURIComponent("" + downloadIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/zip"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFileDownload(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFileDownload(<any>r));
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InboundRedirectApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return InboundRedirectApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) InboundRedirectApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        InboundRedirectApiClient._baseUrl = baseUrl;
    }

    /**
     * Verify redirect parameters
     * @param redirectSource The source of the redirect request
     * @return OK
     */
    verifyRedirectParameters(redirectSource: string, requestParams: { [key: string]: string; }): Observable<InboundRedirectRequestResponseDto> {
        let url_ = this.baseUrl + "/inbound-redirect/verify/{RedirectSource}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (redirectSource === undefined || redirectSource === null)
            throw new Error("The parameter 'redirectSource' must be defined.");
        url_ = url_.replace("{RedirectSource}", encodeURIComponent("" + redirectSource));
        if (requestParams === undefined || requestParams === null)
            throw new Error("The parameter 'requestParams' must be defined and cannot be null.");
        else
            for (let attr in requestParams) {
                if (requestParams.hasOwnProperty(attr)) {
                    url_ += "RequestParams[" + attr + "]=" + encodeURIComponent("" + (<any>requestParams)[attr]) + "&";
                }
            }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processVerifyRedirectParameters(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processVerifyRedirectParameters(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectRequestResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectRequestResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyRedirectParameters(response: HttpResponseBase): Observable<InboundRedirectRequestResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectRequestResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildResponse(body: InboundRedirectPaymentCompletionRequestDto | undefined): Observable<InboundRedirectPaymentCompletionResponseDto> {
        let url_ = this.baseUrl + "/inbound-redirect/build-response/{RedirectSource}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processBuildResponse(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processBuildResponse(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectPaymentCompletionResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectPaymentCompletionResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processBuildResponse(response: HttpResponseBase): Observable<InboundRedirectPaymentCompletionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectPaymentCompletionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PopupApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return PopupApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) PopupApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/public-portal";
    }

    static init(baseUrl: string){
        PopupApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve the data to be displayed in a popup
     * @param businessSystemNo The business system to get popup data from
     * @param dataKey The unique key used to retrieve specific collections of data.
     * @return OK
     */
    getPopupData(businessSystemNo: number, dataKey: string): Observable<PopupDataDto> {
        let url_ = this.baseUrl + "/popup/{BusinessSystemNo}/{DataKey}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (businessSystemNo === undefined || businessSystemNo === null)
            throw new Error("The parameter 'businessSystemNo' must be defined.");
        url_ = url_.replace("{BusinessSystemNo}", encodeURIComponent("" + businessSystemNo));
        if (dataKey === undefined || dataKey === null)
            throw new Error("The parameter 'dataKey' must be defined.");
        url_ = url_.replace("{DataKey}", encodeURIComponent("" + dataKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPopupData(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPopupData(<any>r));
                } catch (e) {
                    return <Observable<PopupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PopupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPopupData(response: HttpResponseBase): Observable<PopupDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PopupDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Format of parameters sent in an HTTP request or response. */
export enum ParameterFormatEnumDto {
    None = "None",
    QueryString = "QueryString",
    Json = "Json",
    Xml = "Xml",
}

/** The status of a transaction initiated from an inbound redirect. */
export enum InboundRedirectReturnCodeEnumDto {
    Unknown = "Unknown",
    Cancel = "Cancel",
    Success = "Success",
    Error = "Error",
}

/** What is the currently active payment integration */
export enum PaymentIntegrationEnumDto {
    Demo = "Demo",
    Nic = "Nic",
    Datacap = "Datacap",
    Celero = "Celero",
    BridgePay = "BridgePay",
    Elavon = "Elavon",
    PointAndPay = "PointAndPay",
    CyberSource = "CyberSource",
    WellsFargo = "WellsFargo",
    Fis = "Fis",
    Paymentus = "Paymentus",
    InvoiceCloud = "InvoiceCloud",
    Govolution = "Govolution",
}

/** A page in the online portal */
export class PageDto implements IPageDto {
    /** Unique ID of page */
    pageId!: number;
    /** Teller Business SystemNo */
    businessSystemNo?: number;
    /** The title at the top of the page */
    title?: string;
    /** The markdown of the info of the page */
    pageInfoMarkDown?: string;
    /** A flag indicating if the search results on this page are to be paginated or not */
    paginatedResults?: any;
    /** Descriptive text for how to use page */
    description?: string;
    /** The list of searches that are available on the page */
    searchTypes?: SearchTypeDto[];
    /** The item types that are available to add to cart */
    itemTypes?: PageItemTypeDescriptionDto[];

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageId = _data["pageId"];
            this.businessSystemNo = _data["businessSystemNo"];
            this.title = _data["title"];
            this.pageInfoMarkDown = _data["pageInfoMarkDown"];
            this.paginatedResults = _data["paginatedResults"];
            this.description = _data["description"];
            if (Array.isArray(_data["searchTypes"])) {
                this.searchTypes = [] as any;
                for (let item of _data["searchTypes"])
                    this.searchTypes!.push(SearchTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["itemTypes"])) {
                this.itemTypes = [] as any;
                for (let item of _data["itemTypes"])
                    this.itemTypes!.push(PageItemTypeDescriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageId"] = this.pageId;
        data["businessSystemNo"] = this.businessSystemNo;
        data["title"] = this.title;
        data["pageInfoMarkDown"] = this.pageInfoMarkDown;
        data["paginatedResults"] = this.paginatedResults;
        data["description"] = this.description;
        if (Array.isArray(this.searchTypes)) {
            data["searchTypes"] = [];
            for (let item of this.searchTypes)
                data["searchTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.itemTypes)) {
            data["itemTypes"] = [];
            for (let item of this.itemTypes)
                data["itemTypes"].push(item.toJSON());
        }
        return data;
    }
}

/** A page in the online portal */
export interface IPageDto {
    /** Unique ID of page */
    pageId: number;
    /** Teller Business SystemNo */
    businessSystemNo?: number;
    /** The title at the top of the page */
    title?: string;
    /** The markdown of the info of the page */
    pageInfoMarkDown?: string;
    /** A flag indicating if the search results on this page are to be paginated or not */
    paginatedResults?: any;
    /** Descriptive text for how to use page */
    description?: string;
    /** The list of searches that are available on the page */
    searchTypes?: SearchTypeDto[];
    /** The item types that are available to add to cart */
    itemTypes?: PageItemTypeDescriptionDto[];

    [key: string]: any;
}

/** Just the basic details of a page in the online portal */
export class PageDetailsDto implements IPageDetailsDto {
    /** Unique ID of page */
    pageId!: number;
    /** Unique key for payment configuration override. */
    configKey?: string;
    /** Teller Business SystemNo */
    businessSystemNo?: number;
    /** The title at the top of the page */
    title?: string;
    /** Descriptive text for how to use page */
    description?: string;

    [key: string]: any;

    constructor(data?: IPageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageId = _data["pageId"];
            this.configKey = _data["configKey"];
            this.businessSystemNo = _data["businessSystemNo"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageId"] = this.pageId;
        data["configKey"] = this.configKey;
        data["businessSystemNo"] = this.businessSystemNo;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

/** Just the basic details of a page in the online portal */
export interface IPageDetailsDto {
    /** Unique ID of page */
    pageId: number;
    /** Unique key for payment configuration override. */
    configKey?: string;
    /** Teller Business SystemNo */
    businessSystemNo?: number;
    /** The title at the top of the page */
    title?: string;
    /** Descriptive text for how to use page */
    description?: string;

    [key: string]: any;
}

/** A light-weight representation of a page item type. */
export class PageItemTypeDescriptionDto implements IPageItemTypeDescriptionDto {
    /** Unique ID of item type */
    pageItemTypeId!: number;
    /** The name of the item */
    name?: string;
    /** Description of the item. */
    description?: string;
    /** Image to display */
    image?: string;
    /** The amount of the item to purchase */
    amount?: number;

    [key: string]: any;

    constructor(data?: IPageItemTypeDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageItemTypeId = _data["pageItemTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PageItemTypeDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageItemTypeDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageItemTypeId"] = this.pageItemTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        data["amount"] = this.amount;
        return data;
    }
}

/** A light-weight representation of a page item type. */
export interface IPageItemTypeDescriptionDto {
    /** Unique ID of item type */
    pageItemTypeId: number;
    /** The name of the item */
    name?: string;
    /** Description of the item. */
    description?: string;
    /** Image to display */
    image?: string;
    /** The amount of the item to purchase */
    amount?: number;

    [key: string]: any;
}

/** A full representation of a page item type. */
export class PageItemTypeDto implements IPageItemTypeDto {
    /** Unique ID of item type */
    pageItemTypeId!: number;
    /** Unique config number within teller */
    tellerItemTypeNo?: number;
    /** The name of the item */
    name?: string;
    /** The unique ItemGuid of the item */
    itemGuid!: string;
    /** Whether or not the item has a quantity ticker */
    hasQuantity?: boolean;
    page?: PageDetailsDto;
    /** Description of the item. */
    description?: string;
    /** Markdown to render in the right "help" column */
    helpText?: string;
    /** List of links to show in the "help" column */
    additionalLinks?: string[];
    /** Image to display */
    image?: string;
    /** The amount of the item to purchase */
    amount?: number;
    /** How the total amount should be calculated if there are calculated fields */
    amountCalculation?: string;
    /** A note displayed next to the total when an AmountCalculation exists, explaining how the total is calculated */
    amountNote?: string;
    /** List of form field groups to include on the page. */
    formInputGroups?: ItemFormInputGroupDto[];

    [key: string]: any;

    constructor(data?: IPageItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageItemTypeId = _data["pageItemTypeId"];
            this.tellerItemTypeNo = _data["tellerItemTypeNo"];
            this.name = _data["name"];
            this.itemGuid = _data["itemGuid"];
            this.hasQuantity = _data["hasQuantity"];
            this.page = _data["page"] ? PageDetailsDto.fromJS(_data["page"]) : <any>undefined;
            this.description = _data["description"];
            this.helpText = _data["helpText"];
            if (Array.isArray(_data["additionalLinks"])) {
                this.additionalLinks = [] as any;
                for (let item of _data["additionalLinks"])
                    this.additionalLinks!.push(item);
            }
            this.image = _data["image"];
            this.amount = _data["amount"];
            this.amountCalculation = _data["amountCalculation"];
            this.amountNote = _data["amountNote"];
            if (Array.isArray(_data["formInputGroups"])) {
                this.formInputGroups = [] as any;
                for (let item of _data["formInputGroups"])
                    this.formInputGroups!.push(ItemFormInputGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageItemTypeId"] = this.pageItemTypeId;
        data["tellerItemTypeNo"] = this.tellerItemTypeNo;
        data["name"] = this.name;
        data["itemGuid"] = this.itemGuid;
        data["hasQuantity"] = this.hasQuantity;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["helpText"] = this.helpText;
        if (Array.isArray(this.additionalLinks)) {
            data["additionalLinks"] = [];
            for (let item of this.additionalLinks)
                data["additionalLinks"].push(item);
        }
        data["image"] = this.image;
        data["amount"] = this.amount;
        data["amountCalculation"] = this.amountCalculation;
        data["amountNote"] = this.amountNote;
        if (Array.isArray(this.formInputGroups)) {
            data["formInputGroups"] = [];
            for (let item of this.formInputGroups)
                data["formInputGroups"].push(item.toJSON());
        }
        return data;
    }
}

/** A full representation of a page item type. */
export interface IPageItemTypeDto {
    /** Unique ID of item type */
    pageItemTypeId: number;
    /** Unique config number within teller */
    tellerItemTypeNo?: number;
    /** The name of the item */
    name?: string;
    /** The unique ItemGuid of the item */
    itemGuid: string;
    /** Whether or not the item has a quantity ticker */
    hasQuantity?: boolean;
    page?: PageDetailsDto;
    /** Description of the item. */
    description?: string;
    /** Markdown to render in the right "help" column */
    helpText?: string;
    /** List of links to show in the "help" column */
    additionalLinks?: string[];
    /** Image to display */
    image?: string;
    /** The amount of the item to purchase */
    amount?: number;
    /** How the total amount should be calculated if there are calculated fields */
    amountCalculation?: string;
    /** A note displayed next to the total when an AmountCalculation exists, explaining how the total is calculated */
    amountNote?: string;
    /** List of form field groups to include on the page. */
    formInputGroups?: ItemFormInputGroupDto[];

    [key: string]: any;
}

/** The definition of a field that appears on an Item Type page's form. */
export class ItemFormInputGroupDto implements IItemFormInputGroupDto {
    /** Header of the group */
    header?: string;
    /** List of form fields to include in the group. */
    formInputs?: ItemFormInputDto[];
    /** List of fields that will be autocalculated based on other input fields */
    calculatedFields?: ItemCalculatedFieldDto[];

    [key: string]: any;

    constructor(data?: IItemFormInputGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.header = _data["header"];
            if (Array.isArray(_data["formInputs"])) {
                this.formInputs = [] as any;
                for (let item of _data["formInputs"])
                    this.formInputs!.push(ItemFormInputDto.fromJS(item));
            }
            if (Array.isArray(_data["calculatedFields"])) {
                this.calculatedFields = [] as any;
                for (let item of _data["calculatedFields"])
                    this.calculatedFields!.push(ItemCalculatedFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemFormInputGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemFormInputGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["header"] = this.header;
        if (Array.isArray(this.formInputs)) {
            data["formInputs"] = [];
            for (let item of this.formInputs)
                data["formInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.calculatedFields)) {
            data["calculatedFields"] = [];
            for (let item of this.calculatedFields)
                data["calculatedFields"].push(item.toJSON());
        }
        return data;
    }
}

/** The definition of a field that appears on an Item Type page's form. */
export interface IItemFormInputGroupDto {
    /** Header of the group */
    header?: string;
    /** List of form fields to include in the group. */
    formInputs?: ItemFormInputDto[];
    /** List of fields that will be autocalculated based on other input fields */
    calculatedFields?: ItemCalculatedFieldDto[];

    [key: string]: any;
}

/** The definition of a field that appears on an Item Type page's form. */
export class ItemFormInputDto implements IItemFormInputDto {
    type?: ItemFormInputTypeEnumDto;
    /** The label to be displayed for the field */
    label?: string;
    /** Programatic name for the field */
    name?: string;
    /** A format to use when displaying the custom value in the description of the item when sent to Teller */
    descriptionFormat?: string;
    /** Whether or not this field is required to proceed */
    required?: boolean;
    /** Value user inputted */
    value?: string;
    /** The order in which this field will appear when displayed (combined with calc items) */
    order?: number;
    /** An optional hint that can appear below the field */
    hint?: string;
    /** List of options to show if the type is dropdown */
    options?: ItemFormInputOptionDto[];

    [key: string]: any;

    constructor(data?: IItemFormInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.label = _data["label"];
            this.name = _data["name"];
            this.descriptionFormat = _data["descriptionFormat"];
            this.required = _data["required"];
            this.value = _data["value"];
            this.order = _data["order"];
            this.hint = _data["hint"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ItemFormInputOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemFormInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemFormInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["label"] = this.label;
        data["name"] = this.name;
        data["descriptionFormat"] = this.descriptionFormat;
        data["required"] = this.required;
        data["value"] = this.value;
        data["order"] = this.order;
        data["hint"] = this.hint;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

/** The definition of a field that appears on an Item Type page's form. */
export interface IItemFormInputDto {
    type?: ItemFormInputTypeEnumDto;
    /** The label to be displayed for the field */
    label?: string;
    /** Programatic name for the field */
    name?: string;
    /** A format to use when displaying the custom value in the description of the item when sent to Teller */
    descriptionFormat?: string;
    /** Whether or not this field is required to proceed */
    required?: boolean;
    /** Value user inputted */
    value?: string;
    /** The order in which this field will appear when displayed (combined with calc items) */
    order?: number;
    /** An optional hint that can appear below the field */
    hint?: string;
    /** List of options to show if the type is dropdown */
    options?: ItemFormInputOptionDto[];

    [key: string]: any;
}

/** The definition of an option that belongs to a field of an Item Type */
export class ItemFormInputOptionDto implements IItemFormInputOptionDto {
    /** The label to be displayed for the option */
    label?: string;
    /** Value to be used when the option is selected */
    value?: string;
    /** Whether or not this option is selected by default */
    default?: boolean;

    [key: string]: any;

    constructor(data?: IItemFormInputOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"];
            this.value = _data["value"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): ItemFormInputOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemFormInputOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label;
        data["value"] = this.value;
        data["default"] = this.default;
        return data;
    }
}

/** The definition of an option that belongs to a field of an Item Type */
export interface IItemFormInputOptionDto {
    /** The label to be displayed for the option */
    label?: string;
    /** Value to be used when the option is selected */
    value?: string;
    /** Whether or not this option is selected by default */
    default?: boolean;

    [key: string]: any;
}

export enum ItemFormInputTypeEnumDto {
    Dropdown = "Dropdown",
    Textbox = "Textbox",
    Radio = "Radio",
    File = "File",
    Checkbox = "Checkbox",
    Date = "Date",
    Textarea = "Textarea",
    Currency = "Currency",
    Numeric = "Numeric",
    FormattedNumeric = "FormattedNumeric",
}

/** The definition of a calculated field that appears on an Item Type page's form */
export class ItemCalculatedFieldDto implements IItemCalculatedFieldDto {
    /** The Teller config item that this calculated field will be tracked to */
    tellerConfigNo?: number;
    /** Value that was calculated */
    value?: number;
    /** The formula used to calculate the value */
    calculation?: string;
    /** The label to be displayed for the field */
    label?: string;
    /** Programatic name for the field */
    name?: string;
    /** The order in which this field will appear when displayed (combined with inputs) */
    order?: number;
    /** Flag indicating if this field should be hidden (type=hidden) */
    hidden?: boolean;

    [key: string]: any;

    constructor(data?: IItemCalculatedFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerConfigNo = _data["tellerConfigNo"];
            this.value = _data["value"];
            this.calculation = _data["calculation"];
            this.label = _data["label"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any): ItemCalculatedFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCalculatedFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerConfigNo"] = this.tellerConfigNo;
        data["value"] = this.value;
        data["calculation"] = this.calculation;
        data["label"] = this.label;
        data["name"] = this.name;
        data["order"] = this.order;
        data["hidden"] = this.hidden;
        return data;
    }
}

/** The definition of a calculated field that appears on an Item Type page's form */
export interface IItemCalculatedFieldDto {
    /** The Teller config item that this calculated field will be tracked to */
    tellerConfigNo?: number;
    /** Value that was calculated */
    value?: number;
    /** The formula used to calculate the value */
    calculation?: string;
    /** The label to be displayed for the field */
    label?: string;
    /** Programatic name for the field */
    name?: string;
    /** The order in which this field will appear when displayed (combined with inputs) */
    order?: number;
    /** Flag indicating if this field should be hidden (type=hidden) */
    hidden?: boolean;

    [key: string]: any;
}

export class SearchTypeDto implements ISearchTypeDto {
    /** Unique name */
    name?: string;
    /** Label to display for the search type */
    label?: string;
    /** Title of instructional text for the search type */
    instructionsTitle?: string;
    /** Detailed instructions for the search */
    instructionsText?: string;
    /** Image to display (maybe a sample bill) */
    instructionsImage?: string;
    /** Alt text to display if image cannot be loaded */
    instructionsImageAltText?: string;
    template?: SearchTemplateDto;
    /** Whether or not the SearchType should be displayed in the UI */
    visible?: boolean;
    /** Whether or not the SearchType supports lookahead search */
    isLookaheadSearch?: boolean;
    /** Name of the field to use for lookahead search. */
    lookaheadField?: string;
    searchFlow?: SearchFlowEnumDto;
    /** Number of results to load and increment by on separated search. */
    loadMoreIncrement?: number;

    [key: string]: any;

    constructor(data?: ISearchTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.label = _data["label"];
            this.instructionsTitle = _data["instructionsTitle"];
            this.instructionsText = _data["instructionsText"];
            this.instructionsImage = _data["instructionsImage"];
            this.instructionsImageAltText = _data["instructionsImageAltText"];
            this.template = _data["template"] ? SearchTemplateDto.fromJS(_data["template"]) : <any>undefined;
            this.visible = _data["visible"];
            this.isLookaheadSearch = _data["isLookaheadSearch"];
            this.lookaheadField = _data["lookaheadField"];
            this.searchFlow = _data["searchFlow"];
            this.loadMoreIncrement = _data["loadMoreIncrement"];
        }
    }

    static fromJS(data: any): SearchTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["label"] = this.label;
        data["instructionsTitle"] = this.instructionsTitle;
        data["instructionsText"] = this.instructionsText;
        data["instructionsImage"] = this.instructionsImage;
        data["instructionsImageAltText"] = this.instructionsImageAltText;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["visible"] = this.visible;
        data["isLookaheadSearch"] = this.isLookaheadSearch;
        data["lookaheadField"] = this.lookaheadField;
        data["searchFlow"] = this.searchFlow;
        data["loadMoreIncrement"] = this.loadMoreIncrement;
        return data;
    }
}

export interface ISearchTypeDto {
    /** Unique name */
    name?: string;
    /** Label to display for the search type */
    label?: string;
    /** Title of instructional text for the search type */
    instructionsTitle?: string;
    /** Detailed instructions for the search */
    instructionsText?: string;
    /** Image to display (maybe a sample bill) */
    instructionsImage?: string;
    /** Alt text to display if image cannot be loaded */
    instructionsImageAltText?: string;
    template?: SearchTemplateDto;
    /** Whether or not the SearchType should be displayed in the UI */
    visible?: boolean;
    /** Whether or not the SearchType supports lookahead search */
    isLookaheadSearch?: boolean;
    /** Name of the field to use for lookahead search. */
    lookaheadField?: string;
    searchFlow?: SearchFlowEnumDto;
    /** Number of results to load and increment by on separated search. */
    loadMoreIncrement?: number;

    [key: string]: any;
}

export class SearchTemplateDto implements ISearchTemplateDto {
    /** fields of template */
    fields?: SearchFieldDto[];

    [key: string]: any;

    constructor(data?: ISearchTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SearchFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchTemplateDto {
    /** fields of template */
    fields?: SearchFieldDto[];

    [key: string]: any;
}

export class SearchFieldDto implements ISearchFieldDto {
    /** Label */
    label?: string;
    /** WidgetType */
    widgetType?: string;
    /** Is required */
    isRequired?: any;
    /** Allow whitespace */
    allowWhitespace?: any;
    /** Input options */
    inputOptions?: string[];
    /** Validations */
    validations?: ValidationSearchDto[];
    /** Name */
    name?: string;

    [key: string]: any;

    constructor(data?: ISearchFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"];
            this.widgetType = _data["widgetType"];
            this.isRequired = _data["isRequired"];
            this.allowWhitespace = _data["allowWhitespace"];
            if (Array.isArray(_data["inputOptions"])) {
                this.inputOptions = [] as any;
                for (let item of _data["inputOptions"])
                    this.inputOptions!.push(item);
            }
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(ValidationSearchDto.fromJS(item));
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SearchFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label;
        data["widgetType"] = this.widgetType;
        data["isRequired"] = this.isRequired;
        data["allowWhitespace"] = this.allowWhitespace;
        if (Array.isArray(this.inputOptions)) {
            data["inputOptions"] = [];
            for (let item of this.inputOptions)
                data["inputOptions"].push(item);
        }
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ISearchFieldDto {
    /** Label */
    label?: string;
    /** WidgetType */
    widgetType?: string;
    /** Is required */
    isRequired?: any;
    /** Allow whitespace */
    allowWhitespace?: any;
    /** Input options */
    inputOptions?: string[];
    /** Validations */
    validations?: ValidationSearchDto[];
    /** Name */
    name?: string;

    [key: string]: any;
}

/** The items that user has added to the dashboard */
export class ValidationSearchDto implements IValidationSearchDto {
    /** RegEx */
    regex?: string;
    /** Value */
    value?: string;

    [key: string]: any;

    constructor(data?: IValidationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.regex = _data["regex"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValidationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["regex"] = this.regex;
        data["value"] = this.value;
        return data;
    }
}

/** The items that user has added to the dashboard */
export interface IValidationSearchDto {
    /** RegEx */
    regex?: string;
    /** Value */
    value?: string;

    [key: string]: any;
}

/** A cart in the online portal */
export class CartDto implements ICartDto {
    /** Unique ID of cart */
    cartId!: number;
    /** Unique GUID of cart */
    cartGuid!: string;
    /** The current version of this cart (in order to track race conditions in javascript) */
    version?: number;
    /** The date/time that this cart was created */
    createdDate?: Date;
    /** The email address of the guest user */
    guestEmailAddress?: string;
    /** Indicates if the user wants to remember their credit card */
    rememberPaymentMethod!: boolean;
    /** payment method id should be used */
    paymentMethodId?: number | undefined;
    /** The items in the cart */
    items?: ItemDto[];
    status!: CartStatusEnumDto;

    [key: string]: any;

    constructor(data?: ICartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
            this.version = _data["version"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.guestEmailAddress = _data["guestEmailAddress"];
            this.rememberPaymentMethod = _data["rememberPaymentMethod"];
            this.paymentMethodId = _data["paymentMethodId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemDto.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        data["version"] = this.version;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["guestEmailAddress"] = this.guestEmailAddress;
        data["rememberPaymentMethod"] = this.rememberPaymentMethod;
        data["paymentMethodId"] = this.paymentMethodId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

/** A cart in the online portal */
export interface ICartDto {
    /** Unique ID of cart */
    cartId: number;
    /** Unique GUID of cart */
    cartGuid: string;
    /** The current version of this cart (in order to track race conditions in javascript) */
    version?: number;
    /** The date/time that this cart was created */
    createdDate?: Date;
    /** The email address of the guest user */
    guestEmailAddress?: string;
    /** Indicates if the user wants to remember their credit card */
    rememberPaymentMethod: boolean;
    /** payment method id should be used */
    paymentMethodId?: number | undefined;
    /** The items in the cart */
    items?: ItemDto[];
    status: CartStatusEnumDto;

    [key: string]: any;
}

/** The items that user has added to the dashboard */
export class DashboardItemDto implements IDashboardItemDto {
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;

    constructor(data?: IDashboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** The items that user has added to the dashboard */
export interface IDashboardItemDto {
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;
}

/** A payable item (fee, tax charge, etc) */
export class ItemDto implements IItemDto {
    /** Unique GUID */
    itemGuid?: string | undefined;
    /** Unique identifier for this BSI in the external system */
    businessSystemItemKey?: string;
    /** The id of the page item type for a misc item */
    pageItemTypeId?: number;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title!: string;
    amountInCart?: number;
    /** Quantity of the items purchased */
    quantity?: number;
    /** Cart Item Custom Values */
    cartItemCustomValue?: CartItemCustomValueDto[];
    page?: PageDetailsDto;
    /** Payment options for this item */
    paymentOptions?: ItemPaymentOptionDto[];
    selectedPaymentOption?: ItemPaymentOptionDto;
    /** The details that fill the body of the Item. */
    details?: ItemDetailDto[];
    /** An optional warning generated by a discrepancy between the item in Teller and the cart */
    warning?: CartItemWarningDto | undefined;
    /** A list of BsiKeys of items that must be paid off in full before / with this item */
    dependencies?: ItemDependencyDto[];
    /** A message to be shown if this item is unpayable due to its dependencies */
    dependencyMessage?: string;

    [key: string]: any;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.itemGuid = _data["itemGuid"];
            this.businessSystemItemKey = _data["businessSystemItemKey"];
            this.pageItemTypeId = _data["pageItemTypeId"];
            this.tellerItemTypeNo = _data["tellerItemTypeNo"];
            this.tellerItemDescription = _data["tellerItemDescription"];
            this.title = _data["title"];
            this.amountInCart = _data["amountInCart"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["cartItemCustomValue"])) {
                this.cartItemCustomValue = [] as any;
                for (let item of _data["cartItemCustomValue"])
                    this.cartItemCustomValue!.push(CartItemCustomValueDto.fromJS(item));
            }
            this.page = _data["page"] ? PageDetailsDto.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["paymentOptions"])) {
                this.paymentOptions = [] as any;
                for (let item of _data["paymentOptions"])
                    this.paymentOptions!.push(ItemPaymentOptionDto.fromJS(item));
            }
            this.selectedPaymentOption = _data["selectedPaymentOption"] ? ItemPaymentOptionDto.fromJS(_data["selectedPaymentOption"]) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ItemDetailDto.fromJS(item));
            }
            this.warning = _data["warning"] ? CartItemWarningDto.fromJS(_data["warning"]) : <any>undefined;
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(ItemDependencyDto.fromJS(item));
            }
            this.dependencyMessage = _data["dependencyMessage"];
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["itemGuid"] = this.itemGuid;
        data["businessSystemItemKey"] = this.businessSystemItemKey;
        data["pageItemTypeId"] = this.pageItemTypeId;
        data["tellerItemTypeNo"] = this.tellerItemTypeNo;
        data["tellerItemDescription"] = this.tellerItemDescription;
        data["title"] = this.title;
        data["amountInCart"] = this.amountInCart;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.cartItemCustomValue)) {
            data["cartItemCustomValue"] = [];
            for (let item of this.cartItemCustomValue)
                data["cartItemCustomValue"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentOptions)) {
            data["paymentOptions"] = [];
            for (let item of this.paymentOptions)
                data["paymentOptions"].push(item.toJSON());
        }
        data["selectedPaymentOption"] = this.selectedPaymentOption ? this.selectedPaymentOption.toJSON() : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["warning"] = this.warning ? this.warning.toJSON() : <any>undefined;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item.toJSON());
        }
        data["dependencyMessage"] = this.dependencyMessage;
        return data;
    }
}

/** A payable item (fee, tax charge, etc) */
export interface IItemDto {
    /** Unique GUID */
    itemGuid?: string | undefined;
    /** Unique identifier for this BSI in the external system */
    businessSystemItemKey?: string;
    /** The id of the page item type for a misc item */
    pageItemTypeId?: number;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title: string;
    amountInCart?: number;
    /** Quantity of the items purchased */
    quantity?: number;
    /** Cart Item Custom Values */
    cartItemCustomValue?: CartItemCustomValueDto[];
    page?: PageDetailsDto;
    /** Payment options for this item */
    paymentOptions?: ItemPaymentOptionDto[];
    selectedPaymentOption?: ItemPaymentOptionDto;
    /** The details that fill the body of the Item. */
    details?: ItemDetailDto[];
    /** An optional warning generated by a discrepancy between the item in Teller and the cart */
    warning?: CartItemWarningDto | undefined;
    /** A list of BsiKeys of items that must be paid off in full before / with this item */
    dependencies?: ItemDependencyDto[];
    /** A message to be shown if this item is unpayable due to its dependencies */
    dependencyMessage?: string;

    [key: string]: any;
}

/** A representation of items that must be paid off before this one */
export class ItemDependencyDto implements IItemDependencyDto {
    /** Business System Item Key of the item depended on */
    bsiKey!: string;
    /** The amount that must be in the cart for the dependent item */
    amount!: number;

    [key: string]: any;

    constructor(data?: IItemDependencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.bsiKey = _data["bsiKey"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ItemDependencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDependencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["bsiKey"] = this.bsiKey;
        data["amount"] = this.amount;
        return data;
    }
}

/** A representation of items that must be paid off before this one */
export interface IItemDependencyDto {
    /** Business System Item Key of the item depended on */
    bsiKey: string;
    /** The amount that must be in the cart for the dependent item */
    amount: number;

    [key: string]: any;
}

/** A payment option for an item */
export class ItemPaymentOptionDto implements IItemPaymentOptionDto {
    /** Unique name for this payment option */
    name!: string;
    /** Label to display */
    label!: string;
    /** Indicates if this payment option represents a custom amount (will require user entry) */
    isCustomAmount!: boolean;
    /** The max amount that can be paid on a custom option */
    maxAmount?: number;
    /** The amount to pay */
    amount?: number;
    /** The minimum amount payable for a Custom Amount on this payment option */
    minAmount?: number;

    [key: string]: any;

    constructor(data?: IItemPaymentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.label = _data["label"];
            this.isCustomAmount = _data["isCustomAmount"];
            this.maxAmount = _data["maxAmount"];
            this.amount = _data["amount"];
            this.minAmount = _data["minAmount"];
        }
    }

    static fromJS(data: any): ItemPaymentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPaymentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["label"] = this.label;
        data["isCustomAmount"] = this.isCustomAmount;
        data["maxAmount"] = this.maxAmount;
        data["amount"] = this.amount;
        data["minAmount"] = this.minAmount;
        return data;
    }
}

/** A payment option for an item */
export interface IItemPaymentOptionDto {
    /** Unique name for this payment option */
    name: string;
    /** Label to display */
    label: string;
    /** Indicates if this payment option represents a custom amount (will require user entry) */
    isCustomAmount: boolean;
    /** The max amount that can be paid on a custom option */
    maxAmount?: number;
    /** The amount to pay */
    amount?: number;
    /** The minimum amount payable for a Custom Amount on this payment option */
    minAmount?: number;

    [key: string]: any;
}

/** Data shown on the footer */
export class FooterLinkDataDto implements IFooterLinkDataDto {
    /** Link title */
    title?: string;
    /** URL of the footer link */
    url?: string;

    [key: string]: any;

    constructor(data?: IFooterLinkDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FooterLinkDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FooterLinkDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["url"] = this.url;
        return data;
    }
}

/** Data shown on the footer */
export interface IFooterLinkDataDto {
    /** Link title */
    title?: string;
    /** URL of the footer link */
    url?: string;

    [key: string]: any;
}

/** The password policy settings from Cognito */
export class PasswordPolicyDto implements IPasswordPolicyDto {
    /** Minimum length that the password must be */
    minimumLength?: number;
    /** If the password must contain at least one lowercase letter */
    requireLowercase?: any;
    /** If the password must contain at least one uppercase letter */
    requireUppercase?: any;
    /** If the password must contain at least one number */
    requireNumbers?: any;
    /** If the password must contain at least one symbol in the following set (  -=+^$*.[]{}()?"!@#%&/\,><':;|_~`  ) */
    requireSymbols?: any;

    [key: string]: any;

    constructor(data?: IPasswordPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.minimumLength = _data["minimumLength"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireUppercase = _data["requireUppercase"];
            this.requireNumbers = _data["requireNumbers"];
            this.requireSymbols = _data["requireSymbols"];
        }
    }

    static fromJS(data: any): PasswordPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["minimumLength"] = this.minimumLength;
        data["requireLowercase"] = this.requireLowercase;
        data["requireUppercase"] = this.requireUppercase;
        data["requireNumbers"] = this.requireNumbers;
        data["requireSymbols"] = this.requireSymbols;
        return data;
    }
}

/** The password policy settings from Cognito */
export interface IPasswordPolicyDto {
    /** Minimum length that the password must be */
    minimumLength?: number;
    /** If the password must contain at least one lowercase letter */
    requireLowercase?: any;
    /** If the password must contain at least one uppercase letter */
    requireUppercase?: any;
    /** If the password must contain at least one number */
    requireNumbers?: any;
    /** If the password must contain at least one symbol in the following set (  -=+^$*.[]{}()?"!@#%&/\,><':;|_~`  ) */
    requireSymbols?: any;

    [key: string]: any;
}

/** Response to posting a payment */
export class PostPaymentResponseDto implements IPostPaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    cartStatus!: CartStatusEnumDto;

    [key: string]: any;

    constructor(data?: IPostPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.emailAddress = _data["emailAddress"];
            this.cartStatus = _data["cartStatus"];
        }
    }

    static fromJS(data: any): PostPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["emailAddress"] = this.emailAddress;
        data["cartStatus"] = this.cartStatus;
        return data;
    }
}

/** Response to posting a payment */
export interface IPostPaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    cartStatus: CartStatusEnumDto;

    [key: string]: any;
}

/** List of payments done by user */
export class UserPaymentsDto implements IUserPaymentsDto {
    /** Cart status */
    status?: string;
    /** PaymentId of the payment */
    paymentId?: number;
    /** Unique identifier for the payment. */
    paymentIdentifier?: string;
    /** Date cart was finalized */
    finalizedDate?: Date;
    /** Teller Receipt No of the posted payment */
    tellerReceiptNo?: string;
    /** Amount paid */
    amount?: number;
    /** Payment method */
    paymentMethod?: string;

    [key: string]: any;

    constructor(data?: IUserPaymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.paymentId = _data["paymentId"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.finalizedDate = _data["finalizedDate"] ? new Date(_data["finalizedDate"].toString()) : <any>undefined;
            this.tellerReceiptNo = _data["tellerReceiptNo"];
            this.amount = _data["amount"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): UserPaymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["paymentId"] = this.paymentId;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["finalizedDate"] = this.finalizedDate ? this.finalizedDate.toISOString() : <any>undefined;
        data["tellerReceiptNo"] = this.tellerReceiptNo;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

/** List of payments done by user */
export interface IUserPaymentsDto {
    /** Cart status */
    status?: string;
    /** PaymentId of the payment */
    paymentId?: number;
    /** Unique identifier for the payment. */
    paymentIdentifier?: string;
    /** Date cart was finalized */
    finalizedDate?: Date;
    /** Teller Receipt No of the posted payment */
    tellerReceiptNo?: string;
    /** Amount paid */
    amount?: number;
    /** Payment method */
    paymentMethod?: string;

    [key: string]: any;
}

export class AddCartEventRequestDto implements IAddCartEventRequestDto {
    /** Cart event message */
    message!: string;

    [key: string]: any;

    constructor(data?: IAddCartEventRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddCartEventRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCartEventRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAddCartEventRequestDto {
    /** Cart event message */
    message: string;

    [key: string]: any;
}

/** Payment details of a cart in the online portal */
export class CartPaymentDetailsDto implements ICartPaymentDetailsDto {
    /** Unique identifier for the cart */
    cartGuid?: string;
    /** Sign-up token associated with the payment */
    signUpToken?: string;
    /** Back url to navigate to after successful payment (optional) */
    externalBackUrl?: string;
    /** Details for the payment(s) on this cart */
    payments?: PaymentReceiptDto[];

    [key: string]: any;

    constructor(data?: ICartPaymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.signUpToken = _data["signUpToken"];
            this.externalBackUrl = _data["externalBackUrl"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(PaymentReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartPaymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartPaymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["signUpToken"] = this.signUpToken;
        data["externalBackUrl"] = this.externalBackUrl;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data;
    }
}

/** Payment details of a cart in the online portal */
export interface ICartPaymentDetailsDto {
    /** Unique identifier for the cart */
    cartGuid?: string;
    /** Sign-up token associated with the payment */
    signUpToken?: string;
    /** Back url to navigate to after successful payment (optional) */
    externalBackUrl?: string;
    /** Details for the payment(s) on this cart */
    payments?: PaymentReceiptDto[];

    [key: string]: any;
}

/** Details of a payment to be viewed after checkout */
export class PaymentReceiptDto implements IPaymentReceiptDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Key to determine which config was used for this payment */
    configKey?: string;
    status!: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    amountInCart?: number;
    /** Total price that was paid for this cart */
    total?: number | undefined;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number | undefined;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number | undefined;
    /** Current failure message while processing the payment */
    currentFailureMessage?: string;
    /** The payment method used */
    paymentMethod?: SavedPaymentMethodDto;
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;

    constructor(data?: IPaymentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.configKey = _data["configKey"];
            this.status = _data["status"];
            this.tellerReceiptNumber = _data["tellerReceiptNumber"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.amountInCart = _data["amountInCart"];
            this.total = _data["total"];
            this.subtotal = _data["subtotal"];
            this.convenienceFee = _data["convenienceFee"];
            this.currentFailureMessage = _data["currentFailureMessage"];
            this.paymentMethod = _data["paymentMethod"] ? SavedPaymentMethodDto.fromJS(_data["paymentMethod"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["configKey"] = this.configKey;
        data["status"] = this.status;
        data["tellerReceiptNumber"] = this.tellerReceiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["amountInCart"] = this.amountInCart;
        data["total"] = this.total;
        data["subtotal"] = this.subtotal;
        data["convenienceFee"] = this.convenienceFee;
        data["currentFailureMessage"] = this.currentFailureMessage;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** Details of a payment to be viewed after checkout */
export interface IPaymentReceiptDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Key to determine which config was used for this payment */
    configKey?: string;
    status: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    amountInCart?: number;
    /** Total price that was paid for this cart */
    total?: number | undefined;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number | undefined;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number | undefined;
    /** Current failure message while processing the payment */
    currentFailureMessage?: string;
    /** The payment method used */
    paymentMethod?: SavedPaymentMethodDto;
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;
}

export class PaymentMethodDto implements IPaymentMethodDto {
    /** The unique ID of a payment method */
    paymentMethodId!: number;
    /** The card brand */
    cardType?: string;
    /** The expiry month/year of the card */
    cardExpiry?: string;
    /** The last 4 digits of the credit card number */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** eCheck Account Type */
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    /** eCheck Account Owner Type */
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** Routing number */
    eCheckRoutingNumber?: string;
    /** Account Number */
    eCheckAccountNumber?: string;
    /** The first line of the Address (e.g. 27 Merry Ln) */
    addressLine1?: string;
    /** The second line of the Address (e.g. Suite 202) */
    addressLine2?: string;
    /** Zip code */
    addressZip?: string;
    /** City */
    addressCity?: string;
    /** Country */
    addressCountry?: string;
    /** ISO Country Code */
    addressCountryCode?: string;
    /** State */
    addressState?: string;
    /** State code */
    addressStateCode?: string;
    /** Phone */
    phone?: string;
    /** Full name */
    fullName?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault?: any;
    /** Identifier of the payment method in the external system */
    walletToken?: string;

    [key: string]: any;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.cardType = _data["cardType"];
            this.cardExpiry = _data["cardExpiry"];
            this.last4Digits = _data["last4Digits"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressZip = _data["addressZip"];
            this.addressCity = _data["addressCity"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.phone = _data["phone"];
            this.fullName = _data["fullName"];
            this.isDefault = _data["isDefault"];
            this.walletToken = _data["walletToken"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["cardType"] = this.cardType;
        data["cardExpiry"] = this.cardExpiry;
        data["last4Digits"] = this.last4Digits;
        data["paymentMethodType"] = this.paymentMethodType;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressZip"] = this.addressZip;
        data["addressCity"] = this.addressCity;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        data["isDefault"] = this.isDefault;
        data["walletToken"] = this.walletToken;
        return data;
    }
}

export interface IPaymentMethodDto {
    /** The unique ID of a payment method */
    paymentMethodId: number;
    /** The card brand */
    cardType?: string;
    /** The expiry month/year of the card */
    cardExpiry?: string;
    /** The last 4 digits of the credit card number */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** eCheck Account Type */
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    /** eCheck Account Owner Type */
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** Routing number */
    eCheckRoutingNumber?: string;
    /** Account Number */
    eCheckAccountNumber?: string;
    /** The first line of the Address (e.g. 27 Merry Ln) */
    addressLine1?: string;
    /** The second line of the Address (e.g. Suite 202) */
    addressLine2?: string;
    /** Zip code */
    addressZip?: string;
    /** City */
    addressCity?: string;
    /** Country */
    addressCountry?: string;
    /** ISO Country Code */
    addressCountryCode?: string;
    /** State */
    addressState?: string;
    /** State code */
    addressStateCode?: string;
    /** Phone */
    phone?: string;
    /** Full name */
    fullName?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault?: any;
    /** Identifier of the payment method in the external system */
    walletToken?: string;

    [key: string]: any;
}

export class SavedPaymentMethodDto implements ISavedPaymentMethodDto {
    /** Payment method id should be used */
    paymentMethodId!: number;
    /** Last 4 difgits of the credit card */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Type of the the credit card */
    cardType?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault!: any;

    [key: string]: any;

    constructor(data?: ISavedPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.last4Digits = _data["last4Digits"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.cardType = _data["cardType"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): SavedPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavedPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["last4Digits"] = this.last4Digits;
        data["paymentMethodType"] = this.paymentMethodType;
        data["cardType"] = this.cardType;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ISavedPaymentMethodDto {
    /** Payment method id should be used */
    paymentMethodId: number;
    /** Last 4 difgits of the credit card */
    last4Digits?: string;
    /** Payment method type (CreditCard or ECheck) */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Type of the the credit card */
    cardType?: string;
    /** Indicates if the payment method is default one for the user */
    isDefault: any;

    [key: string]: any;
}

export class CartItemCustomValueDto implements ICartItemCustomValueDto {
    /** Custom Value Name stored in Teller */
    name!: string;
    /** Value of the Custom Value stored in Teller */
    value!: string;
    /** Text shown to the user in the UI */
    label?: string | undefined;
    /** The group that this custom value is part of to show in UI */
    group?: string | undefined;
    /** An optional config number associated with this custom value. If a config number is associated with it, the item will be added to the payment separately */
    tellerItemConfigNo?: number | undefined;
    /** An optional format to use when displaying the custom value in the description of the item when sent to Teller */
    descriptionFormat?: string | undefined;

    [key: string]: any;

    constructor(data?: ICartItemCustomValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
            this.label = _data["label"];
            this.group = _data["group"];
            this.tellerItemConfigNo = _data["tellerItemConfigNo"];
            this.descriptionFormat = _data["descriptionFormat"];
        }
    }

    static fromJS(data: any): CartItemCustomValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemCustomValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        data["label"] = this.label;
        data["group"] = this.group;
        data["tellerItemConfigNo"] = this.tellerItemConfigNo;
        data["descriptionFormat"] = this.descriptionFormat;
        return data;
    }
}

export interface ICartItemCustomValueDto {
    /** Custom Value Name stored in Teller */
    name: string;
    /** Value of the Custom Value stored in Teller */
    value: string;
    /** Text shown to the user in the UI */
    label?: string | undefined;
    /** The group that this custom value is part of to show in UI */
    group?: string | undefined;
    /** An optional config number associated with this custom value. If a config number is associated with it, the item will be added to the payment separately */
    tellerItemConfigNo?: number | undefined;
    /** An optional format to use when displaying the custom value in the description of the item when sent to Teller */
    descriptionFormat?: string | undefined;

    [key: string]: any;
}

export class ItemDetailDto implements IItemDetailDto {
    /** Description of this detail as provided by the Teller plugin */
    description!: string;
    /** Value of the detail as provided by the Teller plugin */
    value?: string;

    [key: string]: any;

    constructor(data?: IItemDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ItemDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IItemDetailDto {
    /** Description of this detail as provided by the Teller plugin */
    description: string;
    /** Value of the detail as provided by the Teller plugin */
    value?: string;

    [key: string]: any;
}

export class SearchExternalRequestDto implements ISearchExternalRequestDto {
    /** Unique ID of cart */
    cartId!: number;
    /** Business system name */
    businessSystem?: string;
    /** Payment system to choose */
    paymentOption?: string;
    /** Item type */
    itemType?: string;
    /** Payment amount */
    amount!: number;
    /** External back URL */
    backUrl?: string;

    [key: string]: any;

    constructor(data?: ISearchExternalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.businessSystem = _data["businessSystem"];
            this.paymentOption = _data["paymentOption"];
            this.itemType = _data["itemType"];
            this.amount = _data["amount"];
            this.backUrl = _data["backUrl"];
        }
    }

    static fromJS(data: any): SearchExternalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchExternalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["businessSystem"] = this.businessSystem;
        data["paymentOption"] = this.paymentOption;
        data["itemType"] = this.itemType;
        data["amount"] = this.amount;
        data["backUrl"] = this.backUrl;
        return data;
    }
}

export interface ISearchExternalRequestDto {
    /** Unique ID of cart */
    cartId: number;
    /** Business system name */
    businessSystem?: string;
    /** Payment system to choose */
    paymentOption?: string;
    /** Item type */
    itemType?: string;
    /** Payment amount */
    amount: number;
    /** External back URL */
    backUrl?: string;

    [key: string]: any;
}

export class CartResponseDto implements ICartResponseDto {
    cart!: CartDto | undefined;
    warnings!: CartItemWarningDto[] | undefined;

    [key: string]: any;

    constructor(data?: ICartResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cart = _data["cart"] ? CartDto.fromJS(_data["cart"]) : <any>undefined;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(CartItemWarningDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICartResponseDto {
    cart: CartDto | undefined;
    warnings: CartItemWarningDto[] | undefined;

    [key: string]: any;
}

export class AddItemResponseDto implements IAddItemResponseDto {
    cart!: CartResponseDto | undefined;
    newItem!: ItemDto | undefined;

    [key: string]: any;

    constructor(data?: IAddItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cart = _data["cart"] ? CartResponseDto.fromJS(_data["cart"]) : <any>undefined;
            this.newItem = _data["newItem"] ? ItemDto.fromJS(_data["newItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        data["newItem"] = this.newItem ? this.newItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddItemResponseDto {
    cart: CartResponseDto | undefined;
    newItem: ItemDto | undefined;

    [key: string]: any;
}

export class RefreshItemResponseDto implements IRefreshItemResponseDto {
    item!: ItemDto | undefined;
    duplicateItems?: ItemDto[] | undefined;

    [key: string]: any;

    constructor(data?: IRefreshItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.item = _data["item"] ? ItemDto.fromJS(_data["item"]) : <any>undefined;
            if (Array.isArray(_data["duplicateItems"])) {
                this.duplicateItems = [] as any;
                for (let item of _data["duplicateItems"])
                    this.duplicateItems!.push(ItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RefreshItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (Array.isArray(this.duplicateItems)) {
            data["duplicateItems"] = [];
            for (let item of this.duplicateItems)
                data["duplicateItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRefreshItemResponseDto {
    item: ItemDto | undefined;
    duplicateItems?: ItemDto[] | undefined;

    [key: string]: any;
}

export class CartItemWarningDto implements ICartItemWarningDto {
    /** The message to display to the user about the item */
    message!: string;
    /** The unique ItemGuid of the item that has a warning */
    itemGuid?: string;
    /** Whether or not the user needs to act on this warning */
    requiresAction?: any;

    [key: string]: any;

    constructor(data?: ICartItemWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.itemGuid = _data["itemGuid"];
            this.requiresAction = _data["requiresAction"];
        }
    }

    static fromJS(data: any): CartItemWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["itemGuid"] = this.itemGuid;
        data["requiresAction"] = this.requiresAction;
        return data;
    }
}

export interface ICartItemWarningDto {
    /** The message to display to the user about the item */
    message: string;
    /** The unique ItemGuid of the item that has a warning */
    itemGuid?: string;
    /** Whether or not the user needs to act on this warning */
    requiresAction?: any;

    [key: string]: any;
}

export class InboundRedirectRequestResponseDto implements IInboundRedirectRequestResponseDto {
    /** The source of the redirect request. */
    redirectSource!: string;
    /** The payment amount the user wishes to pay. */
    paymentAmount?: number;
    /** The URL the user will be redirected back to once the payment has been completed, canceled, or errored. */
    redirectUrl?: string;
    /** The search key to use to query Teller. */
    searchId?: string;
    /** The full name of the user who submitted the request to redirect to TOL. */
    fullName?: string;
    /** The email address of the user who submitted the request to redirect to TOL. */
    userEmail?: string;
    /** True if request is valid, false if it is not. */
    isValid!: boolean;
    /** Additional details about why the request was invalid. */
    userErrorMessage?: string;
    /** The page that will be used to perform the search. */
    pageId?: number;
    /** The name of the key that will be used to search. */
    searchTypeName?: string;
    /** The amount that will be paid, usually "Full". */
    paymentOptionType?: string;
    /** The friendly name of the inbound redirect source to be presented to the user. */
    friendlyName?: string;
    /** The payment method type the user selected to use optionally provided in the inbound redirect request. */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Flag to determine whether error dialogs should be shown prior to redirect */
    showErrorDialog!: boolean;
    /** The ID belonging to the InboundRedirectSource record that represents the source where this transaction was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** Search values */
    additionalSearchValues?: InboundRedirectSearchValueDto[];

    [key: string]: any;

    constructor(data?: IInboundRedirectRequestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.redirectSource = _data["redirectSource"];
            this.paymentAmount = _data["paymentAmount"];
            this.redirectUrl = _data["redirectUrl"];
            this.searchId = _data["searchId"];
            this.fullName = _data["fullName"];
            this.userEmail = _data["userEmail"];
            this.isValid = _data["isValid"];
            this.userErrorMessage = _data["userErrorMessage"];
            this.pageId = _data["pageId"];
            this.searchTypeName = _data["searchTypeName"];
            this.paymentOptionType = _data["paymentOptionType"];
            this.friendlyName = _data["friendlyName"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.showErrorDialog = _data["showErrorDialog"];
            this.inboundRedirectSourceId = _data["inboundRedirectSourceId"];
            if (Array.isArray(_data["additionalSearchValues"])) {
                this.additionalSearchValues = [] as any;
                for (let item of _data["additionalSearchValues"])
                    this.additionalSearchValues!.push(InboundRedirectSearchValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InboundRedirectRequestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectRequestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["redirectSource"] = this.redirectSource;
        data["paymentAmount"] = this.paymentAmount;
        data["redirectUrl"] = this.redirectUrl;
        data["searchId"] = this.searchId;
        data["fullName"] = this.fullName;
        data["userEmail"] = this.userEmail;
        data["isValid"] = this.isValid;
        data["userErrorMessage"] = this.userErrorMessage;
        data["pageId"] = this.pageId;
        data["searchTypeName"] = this.searchTypeName;
        data["paymentOptionType"] = this.paymentOptionType;
        data["friendlyName"] = this.friendlyName;
        data["paymentMethodType"] = this.paymentMethodType;
        data["showErrorDialog"] = this.showErrorDialog;
        data["inboundRedirectSourceId"] = this.inboundRedirectSourceId;
        if (Array.isArray(this.additionalSearchValues)) {
            data["additionalSearchValues"] = [];
            for (let item of this.additionalSearchValues)
                data["additionalSearchValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInboundRedirectRequestResponseDto {
    /** The source of the redirect request. */
    redirectSource: string;
    /** The payment amount the user wishes to pay. */
    paymentAmount?: number;
    /** The URL the user will be redirected back to once the payment has been completed, canceled, or errored. */
    redirectUrl?: string;
    /** The search key to use to query Teller. */
    searchId?: string;
    /** The full name of the user who submitted the request to redirect to TOL. */
    fullName?: string;
    /** The email address of the user who submitted the request to redirect to TOL. */
    userEmail?: string;
    /** True if request is valid, false if it is not. */
    isValid: boolean;
    /** Additional details about why the request was invalid. */
    userErrorMessage?: string;
    /** The page that will be used to perform the search. */
    pageId?: number;
    /** The name of the key that will be used to search. */
    searchTypeName?: string;
    /** The amount that will be paid, usually "Full". */
    paymentOptionType?: string;
    /** The friendly name of the inbound redirect source to be presented to the user. */
    friendlyName?: string;
    /** The payment method type the user selected to use optionally provided in the inbound redirect request. */
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Flag to determine whether error dialogs should be shown prior to redirect */
    showErrorDialog: boolean;
    /** The ID belonging to the InboundRedirectSource record that represents the source where this transaction was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** Search values */
    additionalSearchValues?: InboundRedirectSearchValueDto[];

    [key: string]: any;
}

export class InboundRedirectPaymentCompletionRequestDto implements IInboundRedirectPaymentCompletionRequestDto {
    /** The source of the inbound redirect request. */
    redirectSource!: string;
    /** The id provided to us by the redirect source that was used to search the source system for fee data. */
    searchId?: string;
    /** The id the payment processor returns to us on successful transaction intended to be used if any follow-up is needed on the payment. */
    processorTransactionId?: string;
    /** The status of the payment. */
    returnCode!: InboundRedirectReturnCodeEnumDto;
    /** A custom message to display to the user. */
    userMessage?: string;
    /** The URL that TOL will redirect back to once a payment is canceled, completed, or failed. */
    redirectUrl?: string;

    [key: string]: any;

    constructor(data?: IInboundRedirectPaymentCompletionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.redirectSource = _data["redirectSource"];
            this.searchId = _data["searchId"];
            this.processorTransactionId = _data["processorTransactionId"];
            this.returnCode = _data["returnCode"];
            this.userMessage = _data["userMessage"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): InboundRedirectPaymentCompletionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectPaymentCompletionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["redirectSource"] = this.redirectSource;
        data["searchId"] = this.searchId;
        data["processorTransactionId"] = this.processorTransactionId;
        data["returnCode"] = this.returnCode;
        data["userMessage"] = this.userMessage;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IInboundRedirectPaymentCompletionRequestDto {
    /** The source of the inbound redirect request. */
    redirectSource: string;
    /** The id provided to us by the redirect source that was used to search the source system for fee data. */
    searchId?: string;
    /** The id the payment processor returns to us on successful transaction intended to be used if any follow-up is needed on the payment. */
    processorTransactionId?: string;
    /** The status of the payment. */
    returnCode: InboundRedirectReturnCodeEnumDto;
    /** A custom message to display to the user. */
    userMessage?: string;
    /** The URL that TOL will redirect back to once a payment is canceled, completed, or failed. */
    redirectUrl?: string;

    [key: string]: any;
}

export class InboundRedirectPaymentCompletionResponseDto implements IInboundRedirectPaymentCompletionResponseDto {
    /** The source of the inbound redirect request. */
    redirectSource!: string;
    /** The format the parameters are expected to be, e.g., QueryString, Json, Xml. */
    parameterFormat!: ParameterFormatEnumDto;
    /** All parameters presented in the expected format. */
    parameterString?: string;
    /** The URL that TOL will redirect back to once a payment is canceled, completed, or failed. */
    redirectUrl?: string;

    [key: string]: any;

    constructor(data?: IInboundRedirectPaymentCompletionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.redirectSource = _data["redirectSource"];
            this.parameterFormat = _data["parameterFormat"];
            this.parameterString = _data["parameterString"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): InboundRedirectPaymentCompletionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectPaymentCompletionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["redirectSource"] = this.redirectSource;
        data["parameterFormat"] = this.parameterFormat;
        data["parameterString"] = this.parameterString;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IInboundRedirectPaymentCompletionResponseDto {
    /** The source of the inbound redirect request. */
    redirectSource: string;
    /** The format the parameters are expected to be, e.g., QueryString, Json, Xml. */
    parameterFormat: ParameterFormatEnumDto;
    /** All parameters presented in the expected format. */
    parameterString?: string;
    /** The URL that TOL will redirect back to once a payment is canceled, completed, or failed. */
    redirectUrl?: string;

    [key: string]: any;
}

export class InboundRedirectSearchValueDto implements IInboundRedirectSearchValueDto {
    /** The name of the search key */
    name!: string;
    /** The value associated with the search key */
    value!: string | undefined;

    [key: string]: any;

    constructor(data?: IInboundRedirectSearchValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InboundRedirectSearchValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectSearchValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IInboundRedirectSearchValueDto {
    /** The name of the search key */
    name: string;
    /** The value associated with the search key */
    value: string | undefined;

    [key: string]: any;
}

/** Data that populates the popup */
export class PopupDataDto implements IPopupDataDto {
    header?: string;
    description?: string;
    details?: { [key: string]: string; };
    popupDataTables?: PopupDataTableDto[];

    [key: string]: any;

    constructor(data?: IPopupDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.header = _data["header"];
            this.description = _data["description"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (<any>this.details)![key] = _data["details"][key];
                }
            }
            if (Array.isArray(_data["popupDataTables"])) {
                this.popupDataTables = [] as any;
                for (let item of _data["popupDataTables"])
                    this.popupDataTables!.push(PopupDataTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PopupDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PopupDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["header"] = this.header;
        data["description"] = this.description;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (<any>data["details"])[key] = (<any>this.details)[key];
            }
        }
        if (Array.isArray(this.popupDataTables)) {
            data["popupDataTables"] = [];
            for (let item of this.popupDataTables)
                data["popupDataTables"].push(item.toJSON());
        }
        return data;
    }
}

/** Data that populates the popup */
export interface IPopupDataDto {
    header?: string;
    description?: string;
    details?: { [key: string]: string; };
    popupDataTables?: PopupDataTableDto[];

    [key: string]: any;
}

/** Data that populates a table in the popup */
export class PopupDataTableDto implements IPopupDataTableDto {
    header?: string | undefined;
    columnMetadata?: PopupDataTableColumnMetadataDto[];
    rows?: string[][];
    footer?: string[] | undefined;

    [key: string]: any;

    constructor(data?: IPopupDataTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.header = _data["header"];
            if (Array.isArray(_data["columnMetadata"])) {
                this.columnMetadata = [] as any;
                for (let item of _data["columnMetadata"])
                    this.columnMetadata!.push(PopupDataTableColumnMetadataDto.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            if (Array.isArray(_data["footer"])) {
                this.footer = [] as any;
                for (let item of _data["footer"])
                    this.footer!.push(item);
            }
        }
    }

    static fromJS(data: any): PopupDataTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PopupDataTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["header"] = this.header;
        if (Array.isArray(this.columnMetadata)) {
            data["columnMetadata"] = [];
            for (let item of this.columnMetadata)
                data["columnMetadata"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        if (Array.isArray(this.footer)) {
            data["footer"] = [];
            for (let item of this.footer)
                data["footer"].push(item);
        }
        return data;
    }
}

/** Data that populates a table in the popup */
export interface IPopupDataTableDto {
    header?: string | undefined;
    columnMetadata?: PopupDataTableColumnMetadataDto[];
    rows?: string[][];
    footer?: string[] | undefined;

    [key: string]: any;
}

/** Data that populates a table in the popup */
export class PopupDataTableColumnMetadataDto implements IPopupDataTableColumnMetadataDto {
    title?: string | undefined;
    contentAlignment?: PopupDataTableColumnMetadataDtoContentAlignment;

    [key: string]: any;

    constructor(data?: IPopupDataTableColumnMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.contentAlignment = _data["contentAlignment"];
        }
    }

    static fromJS(data: any): PopupDataTableColumnMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PopupDataTableColumnMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["contentAlignment"] = this.contentAlignment;
        return data;
    }
}

/** Data that populates a table in the popup */
export interface IPopupDataTableColumnMetadataDto {
    title?: string | undefined;
    contentAlignment?: PopupDataTableColumnMetadataDtoContentAlignment;

    [key: string]: any;
}

/** Supported payment method types */
export enum PaymentMethodTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
    Undetermined = "Undetermined",
}

/** The desired search flow functionality for an item. */
export enum SearchFlowEnumDto {
    Standard = "Standard",
    Separated = "Separated",
    Direct = "Direct",
}

/** Status of a cart. */
export enum CartStatusEnumDto {
    Open = "Open",
    CheckingOut = "CheckingOut",
    Processing = "Processing",
    Finalized = "Finalized",
    Closed = "Closed",
}

/** Status of a payment. */
export enum PaymentStatusEnumDto {
    PreProcessing = "PreProcessing",
    Processing = "Processing",
    Processed = "Processed",
    ProcessingFailed = "ProcessingFailed",
    Failed = "Failed",
    Posting = "Posting",
    Posted = "Posted",
    PostingFailed = "PostingFailed",
    PendingReview = "PendingReview",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Finalized = "Finalized",
}

/** Allowed Account Types for EChecks */
export enum ECheckAccountTypeEnumDto {
    Checking = "Checking",
    Savings = "Savings",
}

/** Allowed Account Ownership Types for EChecks */
export enum ECheckAccountOwnerTypeEnumDto {
    Personal = "Personal",
    Business = "Business",
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;

    [key: string]: any;
}

export enum PopupDataTableColumnMetadataDtoContentAlignment {
    Left = "Left",
    Center = "Center",
    Right = "Right",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class InternalApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isInternalApiException = true;

    static isInternalApiException(obj: any): obj is InternalApiException {
        return obj.isInternalApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new InternalApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}